export default __webpack_public_path__ + "static/media/star-yellow.b19af97c.svg";